import React from "react"
import Layout from "../components/containers/layout"
import Seo from "../components/containers/seo"
import { getRoute, ROUTES_ID } from "../constants/routes.contants"

const MentionsLegals = () => {
  const route = getRoute(ROUTES_ID.MENTIONS)
  return (
    <>
      <Seo title={route.screenTitle} />
      <Layout className="user-informations">
        <h2>Mentions légales</h2>
        <p>
          Avenir Conseils et Investissements
          <br />
          N° ORIAS : 19000591 (
          <a href="www.orias.fr" target="_blank" rel="noreferrer">
            www.orias.fr
          </a>
          )
          <br />
          N° SIREN : 844 540 997 R.C.S. Orléans
          <br />
          SASU au capital social de 1000€
          <br />
          Siège social : 2 rue des Tonneliers, 45150 JARGEAU
          <br />
          Code NAF : 66.22Z (Activités des agents et courtiers d'assurances)
          <br />
          TVA FR75844540997
          <br />
          <br />
          Habilité à intervenir, en qualité d’agent commercial, pour le compte
          de Stellium Immobilier SAS
          <br />
          Société au capital social de 150 000 € - RCS Toulouse 384 850 095 - 11
          Avenue Parmentier - CS 70117 - 31201 Toulouse Cedex 2 Carte
          professionnelle n° CPI 3101 2015 000 001 813 « Transaction sur
          immeubles et fonds de commerce » sans détention de fonds, délivrée par
          la Chambre de Commerce et d’Industrie de Toulouse.
          <br />
          Attestation d’habilitation conforme aux dispositions du décret
          n°72-678 du 20 juillet 1972.
          <br />
          <br />
          Adhérent de l’association professionnelle : ANACOFI-COURTAGE
          <br />
          <br />
          Mandataire d’Intermédiaire d’Assurance agissant pour le compte de
          Stellium Courtage
          <br />
          Société de courtage d'assurance de type B au capital social de 350 000
          € - RCS Toulouse 421 956 509 - n° ORIAS : 07 008 919 - 11 Avenue
          Parmentier - CS 70117 - 31201 Toulouse Cedex 2 – Activité contrôlable
          par l’ACPR - Autorité de Contrôle Prudentiel et de Résolution - 4
          place de Budapest, 75 436 Paris cedex 9,{" "}
          <a href="www.acpr.banque-france.fr" target="_blank" rel="noreferrer">
            www.acpr.banque-france.fr
          </a>{" "}
          - Garantie financière et assurance de responsabilité civile
          professionnelle conforme au code des assurances -{" "}
          <a href="www.orias.fr" target="_blank" rel="noreferrer">
            www.orias.fr
          </a>
          ., hors assurance décès invalidité.
          <br />
          Stellium Courtage exerce son activité de courtage d’assurance
          conformément à l’article L.521-2, II, 1° b) du Code des assurances.
          <br />
          Stellium Courtage délivre un conseil basé sur les connaissances et
          l’expérience financière du client ainsi que sa situation financière et
          ses objectifs de souscription. Stellium Courtage vérifie que le
          contrat proposé est cohérent avec les exigences et les besoins du
          client en matière d’assurance (conseil niveau 1).
          <br />
          La société ne fournit pas de service de recommandation personnalisé au
          sens de L 522-5 II du Code des assurances et ne vous remettra pas
          d’évaluation périodique du produit sélectionné au regard de vos
          exigences et besoins.
          <br />
          La société Stellium Courtage est rémunérée sous la forme de
          commissions négociées auprès de nos fournisseurs. Une partie de nos
          commissions est rétrocédée à votre interlocuteur, mandataire de
          Stellium Courtage.
          <br />
          La société Stellium Courtage ne détient aucune participation directe
          ou indirecte dans une entreprise d’assurance. Aucune entreprise
          d’assurance ne détient de participation directe ou indirecte dans la
          société.
          <br />
          Le mandataire distribue exclusivement les produits des fournisseurs
          référencés par Stellium Courtage qui sont les suivants :
          <br />
          Assureurs : Suravenir (Vie Plus), APICIL Assurances, APICIL LIFE,
          APICIL Epargne Retraite
          <br />
          Courtier Grossistes : ODDO BHF avec les assureurs suivants Génération
          Vie & Generali Vie, Primonial avec les assureurs Suravenir &Oradea
          vie, Eres avec les assureurs suivants Swiss life & Spirica, Digital
          Insure avec les assureurs suivants Groupama Gan Vie & AG2R La Mondiale
          & Miltis
          <br />
          <br />
          Mandataire d’Intermédiaire en Opérations de Banque et en Services de
          paiement de Stellium Financement
          <br />
          Agissant en tant que Démarcheur bancaire et financier et Mandataire
          d’Intermédiaire d’Assurance pour le compte de Stellium Financement
          <br />
          STELLIUM FINANCEMENT - Courtier en Opérations de Banque et en Services
          de paiement et Courtier d’Assurance - Société par actions simplifiée
          au capital de 100 000 € - RCS Toulouse 842 612 707 - 11 avenue
          parmentier, CS 70 117, 31 201 Toulouse cedex 2 - n° ORIAS 18 006 415,
          Activité contrôlable par l’ACPR - Autorité de Contrôle Prudentiel et
          de Résolution - 4 place de Budapest, 75 436 Paris cedex 9, Assurance
          de responsabilité civile professionnelle conforme au code monétaire et
          financier.
          <br />
          Dans le cadre de son activité d’Intermédiaire en opération de banque,
          Stellium Financement peut percevoir de la part des partenaires
          bancaires une commission ainsi que des honoraires de courtage au titre
          du mandat de recherche de capitaux. Dans ce cas, le Mandataire pourra
          percevoir une quote-part des honoraires de courtage rétrocédé par
          Stellium Financement. Le cas échéant, Stellium Financement peut être
          amené à proposer un service de conseil au sens de l’Article 519-1-1 du
          CMF. Dans ce cas, les modalités de rémunération dues par le client
          seront précisées dans le mandat de conseil.
          <br />
          Les partenaires de STELLIUM Financement sont notamment : BNP, CFCAL,
          Caisse d’Epargne, LCL, ARKEA. La liste exhaustive des partenaires
          bancaires peut être obtenu sur le site :
          <a
            href="https://www.stellium.fr/partenaires-bancaires-de-stellium-financement"
            target="_blank"
            rel="noreferrer"
          >
            https://www.stellium.fr/partenaires-bancaires-de-stellium-financement
          </a>
          . Stellium Financement a enregistré au cours du dernier exercice plus
          d’un tiers de son Chiffre d’Affaires avec le CFCAL et ARKEA.
          <br />
          <br />
          Conseiller en Investissements Financiers, membre n°E009212 de
          l'ANACOFI-CIF, association agrée par l’Autorité des Marchés Financiers
          (AMF), 17 Place de la Bourse 75082 Paris cedex 02 (
          <a href="www.amf-france.org" target="_blank" rel="noreferrer">
            www.amf-france.org
          </a>
          ), dont il s’est engagé à respecter le Code de bonne
          conduite/déontologie.
          <br />
          Distributeur de Stellium Invest - Société par actions simplifiée au
          capital de 950 000 € - RCS Toulouse 538 449 612 - 11 Avenue Parmentier
          - CS 70117 - 31201 Toulouse Cedex 2 Entreprise d’investissement agréée
          par l’ACPR - Autorité de Contrôle Prudentiel et de Résolution - 4
          place de Budapest, 75 436 Paris Cedex 09,{" "}
          <a href="www.acpr.banque-france.fr" target="_blank" rel="noreferrer">
            www.acpr.banque-france.fr
          </a>{" "}
          - sous le n° 10983 N.
          <br />
          Le service de conseil en investissement est délivré par le conseiller
          en investissement financier, à titre non indépendant. Il se limite à
          la gamme de produits sélectionnés et référencés par Stellium Invest
          auprès de sociétés de gestion et d’émetteurs de titres avec lesquels
          Stellium Invest est lié contractuellement.
          <br />
          Stellium Invest fournit le service de Réception et transmission
          d’ordres, pour le compte du CIF, à l’investisseur final.
          <br />
          Au regard de la procédure de gouvernance et de la politique de
          gouvernance produits de Stellium Invest, le consultant est susceptible
          de proposer des Instruments Financiers prenant en compte les facteurs
          de durabilité, tels que les questions environnementales, sociales et
          de personnel, en choisissant des producteurs de produits qui
          contribuent à la lutte contre le changement climatique et qui
          intègrent les facteurs ESG et ou ISR dans leurs politiques.
          <br />
          A ce titre, Stellium Invest perçoit des commissions de distribution
          des producteurs qui seront prélevés sur les frais du produit (frais
          d’entrée et frais de gestion). Stellium Invest rétrocèdera une
          quote-part de cette commission à votre interlocuteur CIF.
          <br />
          Préalablement à toute souscription, la nature et le détail des
          commissions seront précisés dans un document joint à la déclaration
          d’adéquation.
          <br />
          Les moyens de communication entre le CIF et le client sont l’email, le
          téléphone, la visio et le SMS.
          <br />
          Les sociétés référencées par Stellium Invest sont les suivantes :
          Advenis IM, Alderan, Altarea REIM, Alto Eiffel, Arkea REIM, Atream,
          Elevation Capital Partners (Inter Invest), La Française REIM, Mata
          Capital, Norma Capital, Nextstage AM, Odyssée Venture, Périal AM,
          Urban, Voisin, Sofidy.
          <br />
          En fonction de la nature des instruments financiers, il est enfin
          précisé qu’une évaluation périodique de l’adéquation pourra être
          réalisée.
          <br />
          <br />
          Sous le contrôle de l’Autorité de Contrôle Prudentiel et de Résolution
          - ACPR, 61 rue Taitbout 75346 Paris Cedex 9
          (https://acpr.banque-france.fr/)
          <br />
          <br />
          Garantie Financière et Assurance Responsabilité Civile Professionnelle
          conformes au Code des Assurances
          <br />
        </p>
        <h3>Informations légales</h3>
        <h4>1. Présentation du site.</h4>
        <p>
          En vertu de l’article 6 de la loi n° 2004-575 du 21 juin 2004 pour la
          confiance dans l’économie numérique, il est précisé aux utilisateurs
          du site https://www.aci-conseils.fr l’identité des différents
          intervenants dans le cadre de sa réalisation et de son suivi :
          <br />
          <br />
          Propriétaire : Sébastien Outreville – 15 rue de la Haute Borne - 94880
          - Noiseau
          <br />
          Créateur : Outeville Cédric
          <br />
          Responsable publication : Sébastien Outreville – outreville@gmail.com
          <br />
          Le responsable publication est une personne physique ou une personne
          morale.
          <br />
          Webmaster : Cédric Outreville
          <br />
          Hébergeur : LWS – 10 rue Penthièvre 75008 Paris - FRANCE
          <br />
          Crédits :<br />
          Le modèle de mentions légales est offert par Subdelirium.com Modèle de
          mentions légales
        </p>
        <h4>
          2. Conditions générales d’utilisation du site et des services
          proposés.
        </h4>
        <p>
          L’utilisation du site www.aci-conseils.fr implique l’acceptation
          pleine et entière des conditions générales d’utilisation ci-après
          décrites. Ces conditions d’utilisation sont susceptibles d’être
          modifiées ou complétées à tout moment, les utilisateurs du site
          www.aci-conseils.fr sont donc invités à les consulter de manière
          régulière.
          <br />
          Ce site est normalement accessible à tout moment aux utilisateurs. Une
          interruption pour raison de maintenance technique peut être toutefois
          décidée par Sébastien Outreville, qui s’efforcera alors de communiquer
          préalablement aux utilisateurs les dates et heures de l’intervention.
          <br />
          Le site www.aci-conseils.fr est mis à jour régulièrement par Sébastien
          Outreville. De la même façon, les mentions légales peuvent être
          modifiées à tout moment : elles s’imposent néanmoins à l’utilisateur
          qui est invité à s’y référer le plus souvent possible afin d’en
          prendre connaissance.
        </p>
        <h4>3. Description des services fournis.</h4>
        <p>
          Le site www.aci-conseils.fr a pour objet de fournir une information
          concernant l’ensemble des activités de la société.
          <br />
          Sébastien Outreville s’efforce de fournir sur le site
          www.aci-conseils.fr des informations aussi précises que possible.
          Toutefois, il ne pourra être tenue responsable des omissions, des
          inexactitudes et des carences dans la mise à jour, qu’elles soient de
          son fait ou du fait des tiers partenaires qui lui fournissent ces
          informations.
          <br />
          Tous les informations indiquées sur le site www.aci-conseils.fr sont
          données à titre indicatif, et sont susceptibles d’évoluer. Par
          ailleurs, les renseignements figurant sur le site www.aci-conseils.fr
          ne sont pas exhaustifs. Ils sont donnés sous réserve de modifications
          ayant été apportées depuis leur mise en ligne.
        </p>
        <h4>4. Limitations contractuelles sur les données techniques.</h4>
        <p>
          Le site utilise la technologie JavaScript.
          <br />
          Le site Internet ne pourra être tenu responsable de dommages matériels
          liés à l’utilisation du site. De plus, l’utilisateur du site s’engage
          à accéder au site en utilisant un matériel récent, ne contenant pas de
          virus et avec un navigateur de dernière génération mis-à-jour
        </p>
        <h4>5. Propriété intellectuelle et contrefaçons.</h4>
        <p>
          Sébastien Outreville est propriétaire des droits de propriété
          intellectuelle ou détient les droits d’usage sur tous les éléments
          accessibles sur le site, notamment les textes, images, graphismes,
          logo, icônes, sons, logiciels.
          <br />
          Toute reproduction, représentation, modification, publication,
          adaptation de tout ou partie des éléments du site, quel que soit le
          moyen ou le procédé utilisé, est interdite, sauf autorisation écrite
          préalable de : Sébastien Outreville.
          <br />
          Toute exploitation non autorisée du site ou de l’un quelconque des
          éléments qu’il contient sera considérée comme constitutive d’une
          contrefaçon et poursuivie conformément aux dispositions des articles
          L.335-2 et suivants du Code de Propriété Intellectuelle.
        </p>
        <h4>6. Limitations de responsabilité.</h4>
        <p>
          Sébastien Outreville ne pourra être tenue responsable des dommages
          directs et indirects causés au matériel de l’utilisateur, lors de
          l’accès au site www.aci-conseils.fr, et résultant soit de
          l’utilisation d’un matériel ne répondant pas aux spécifications
          indiquées au point 4, soit de l’apparition d’un bug ou d’une
          incompatibilité.
          <br />
          Sébastien Outreville ne pourra également être tenue responsable des
          dommages indirects (tels par exemple qu’une perte de marché ou perte
          d’une chance) consécutifs à l’utilisation du site www.aci-conseils.fr.
          <br />
          Des espaces interactifs (possibilité de poser des questions dans
          l’espace contact) sont à la disposition des utilisateurs. Sébastien
          Outreville se réserve le droit de supprimer, sans mise en demeure
          préalable, tout contenu déposé dans cet espace qui contreviendrait à
          la législation applicable en France, en particulier aux dispositions
          relatives à la protection des données. Le cas échéant, Sébastien
          Outreville se réserve également la possibilité de mettre en cause la
          responsabilité civile et/ou pénale de l’utilisateur, notamment en cas
          de message à caractère raciste, injurieux, diffamant, ou
          pornographique, quel que soit le support utilisé (texte,
          photographie…).
        </p>
        <h4>7. Gestion des données personnelles.</h4>
        <p>
          Responsables de traitement :
          <br />
          Conformément à la règlementation en vigueur en matière de protection
          des données personnelles, les données de l’investisseur et/ou du
          prospect sont collectées :
          <br />
          - Par le Consultant pour le compte des co-responsables de traitement à
          savoir les sociétés Stellium Invest, Stellium Courtage, Stellium
          Immobilier ou Stellium Financement,
          <br />
          - Ou le cas échéant par le CIF, également co-responsable du
          traitement.
          <br />
          <br />
          Destinataires des données personnelles :
          <br />
          Le Consultant et les sociétés Stellium Invest, Stellium Courtage,
          Stellium Immobilier ou Stellium Financement sont destinataires de
          l’ensemble des données collectées.
          <br />
          <br />
          Finalité du traitement :
          <br />
          Les données personnelles sont traitées afin de permettre aux
          responsables de traitement de respecter leur obligation légale
          d’information sur leurs habilitations.
          <br />
          <br />
          Durée de conservation des données :
          <br />
          Les données personnelles des prospects, le CIF, Stellium Courtage,
          Stellium Invest, Stellium Immobilier ou Stellium Financement
          s’engagent à les supprimer un an après l’entrée en relation s’il n’y a
          pas eu de souscription ou de mise à jour de leurs informations.
          <br />
          <br />
          Droits des personnes concernées :
          <br />
          Le prospect bénéficie d’un droit d’accès, de rectification,
          d’effacement ou de portabilité des données ainsi qu’un droit de
          limitation ou d’opposition au traitement de ses données personnelles
          qu’il peut exercer à l’adresse suivante : rgpd@stellium.fr
          <br />
          Le prospect peut introduire une réclamation au sujet du traitement de
          ses données personnelles auprès de la CNIL.
          <br />
          <br />
          Politique de protection des données :
          <br />
          Pour plus d’information, nous vous invitons à consulter notre
          politique de protection des données présentes présente sur le site
          internet des sociétés Stellium :
          <a
            href="https://www.stellium.fr/traitement-donnees-personnelles/"
            target="_blank"
            rel="noreferrer"
          >
            https://www.stellium.fr/traitement-donnees-personnelles/
          </a>
        </p>
        <h4>8. Liens hypertextes et cookies.</h4>
        <p>
          Le site www.aci-conseils.fr contient un certain nombre de liens
          hypertextes vers d’autres sites, mis en place avec l’autorisation de
          Sébastien Outreville. Cependant, Sébastien Outreville n’a pas la
          possibilité de vérifier le contenu des sites ainsi visités, et
          n’assumera en conséquence aucune responsabilité de ce fait.
          <br />
          La navigation sur le site www.aci-conseils.fr est susceptible de
          provoquer l’installation de cookie(s) sur l’ordinateur de
          l’utilisateur. Un cookie est un fichier de petite taille, qui ne
          permet pas l’identification de l’utilisateur, mais qui enregistre des
          informations relatives à la navigation d’un ordinateur sur un site.
          Les données ainsi obtenues visent à faciliter la navigation ultérieure
          sur le site, et ont également vocation à permettre diverses mesures de
          fréquentation.
          <br />
          Le refus d’installation d’un cookie peut entraîner l’impossibilité
          d’accéder à certains services. L’utilisateur peut toutefois configurer
          son ordinateur de la manière suivante, pour refuser l’installation des
          cookies :
          <br />
          Sous Internet Explorer : onglet outil (pictogramme en forme de rouage
          en haut a droite) / options internet. Cliquez sur Confidentialité et
          choisissez Bloquer tous les cookies. Validez sur Ok.
          <br />
          Sous Firefox : en haut de la fenêtre du navigateur, cliquez sur le
          bouton Firefox, puis aller dans l’onglet Options. Cliquer sur l’onglet
          Vie privée.
          <br />
          Paramétrez les Règles de conservation sur : utiliser les paramètres
          personnalisés pour l’historique. Enfin décochez-la pour désactiver les
          cookies.
          <br />
          Sous Safari : Cliquez en haut à droite du navigateur sur le
          pictogramme de menu (symbolisé par un rouage). Sélectionnez
          Paramètres. Cliquez sur Afficher les paramètres avancés. Dans la
          section « Confidentialité », cliquez sur Paramètres de contenu. Dans
          la section « Cookies », vous pouvez bloquer les cookies.
          <br />
          Sous Chrome : Cliquez en haut à droite du navigateur sur le
          pictogramme de menu (symbolisé par trois lignes horizontales).
          Sélectionnez Paramètres. Cliquez sur Afficher les paramètres avancés.
          Dans la section « Confidentialité », cliquez sur préférences. Dans
          l’onglet « Confidentialité », vous pouvez bloquer les cookies.
        </p>
        <h4>9. Droit applicable et attribution de juridiction.</h4>
        <p>
          Tout litige en relation avec l’utilisation du site www.aci-conseils.fr
          est soumis au droit français. Il est fait attribution exclusive de
          juridiction aux tribunaux compétents de Paris.
        </p>
        <h4>10. Les principales lois concernées.</h4>
        <p>
          Loi n° 78-17 du 6 janvier 1978, notamment modifiée par la loi n°
          2004-801 du 6 août 2004 relative à l’informatique, aux fichiers et aux
          libertés.
          <br />
          Loi n° 2004-575 du 21 juin 2004 pour la confiance dans l’économie
          numérique.
        </p>
        <h4>11. Lexique.</h4>
        <p>
          Utilisateur : Internaute se connectant, utilisant le site susnommé.
          <br />
          Informations personnelles : « les informations qui permettent, sous
          quelque forme que ce soit, directement ou non, l’identification des
          personnes physiques auxquelles elles s’appliquent » (article 4 de la
          loi n° 78-17 du 6 janvier 1978).
        </p>
        <h4> 12. Traitement des réclamations</h4>
        <p>
          Pour toute réclamation, 2 possibilités :
          <br />
          - Vous pouvez formuler votre réclamation à votre Consultant, en lui
          adressant un courrier à l’adresse mail ou postale précisée ci-dessus.
          <br />- Ou adresser votre réclamation à en fonction du produit
          concerné à Stellium Invest (pour les instruments financiers), à
          Stellium Courtage (produits d’assurance), à Stellium Financement (pour
          les opérations de crédit) ou Stellium Immobilier (pour les produits
          immobiliers) à l’adresse suivante : Direction Générale - 11 avenue
          Parmentier - 31 200 Toulouse. Vous trouverez toutes les modalités de
          traitement des réclamations sur le site{" "}
          <a href="www.stellium.fr" target="_blank" rel="noreferrer">
            www.stellium.fr
          </a>
          .
          <br />
          <br />
          Toute réclamation doit faire l’objet d’un traitement dans les délais
          suivants :
          <br />
          - Dix jours ouvrables maximum à compter de l’envoi de la réclamation,
          pour accuser réception, sauf si la réponse elle-même est apportée au
          client dans ce délai ;
          <br />
          - Deux mois maximum entre la date d’envoi de la réclamation et la date
          d’envoi de la réponse à l’investisseur.
          <br />
        </p>
        <h4>13. Assurance RCP</h4>
        <p>
          Nom de l’assureur : ZURICH INSURANCE PLC
          <br />
          Adresse de l’assureur : 112 avenue de Wagram 75017
          <br />
          Le montant de la RCP par année d’assurance est de 2 000 000 € pour
          chacune des catégories Immo, IOBSP, IAS & CIF.
          <br />
        </p>
        <h4>14. Médiateurs</h4>
        <p>
          Médiateur compétent pour les activités d’IOBSP et Immobilières & pour
          les activités d'assurance : AME Conso 197 Boulevard Saint-Germain
          75007 Paris
          <br />
          <br />
          Médiateur compétent pour l’activité de CIF :
          <br />
          Mme Marielle Cohen-Branche
          <br />
          Médiateur de l'AMF - Autorité des Marchés Financiers 17, place de la
          Bourse 75082 Paris cedex 02
          <br />
          Site internet :
          <a
            href="https://www.amf-france.org/fr/le-mediateur-de-lamf/votre-dossier-de-mediation/vous-voulez-deposer-une-demande-de-mediation"
            target="_blank"
            rel="noreferrer"
          >
            https://www.amf-france.org/fr/le-mediateur-de-lamf/votre-dossier-de-mediation/vous-voulez-deposer-une-demande-de-mediation
          </a>
        </p>
      </Layout>
    </>
  )
}

export default MentionsLegals
